<!-- @defer (prefetch on immediate) { -->
<cc-sub-navigation-menu [lobbyType]="lobbyType" [categoryRoute]="categoryRoute" [stickyInputQueryElement]="stickyInputQueryElement" />
<!-- } -->
